import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import CustomDrawer from './CustomDrawer';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '620px',
    backgroundColor: '#f1f1f1',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  }
}));

function ExportDataFilter ({ type }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [state, setState] = React.useState(false);

  return (
    <div>
      <React.Fragment key={'right'}>
        <Button
          color='primary'
          aria-label='Export'
          variant='outlined'
          disableElevation
          onClick={() => setState(true)}
          id='export-button'
        >
          {t('csvInfo:export')}
        </Button>
        <Drawer onClose={() => setState(false)} anchor={'right'} open={state} PaperProps={{ className: classes.container }}>
          {state && <CustomDrawer type={type} toggleDrawer={setState} />}
        </Drawer>
      </React.Fragment>
    </div>
  );
}

ExportDataFilter.propTypes = {
  type: PropTypes.string.isRequired
};

export default ExportDataFilter;
